import React from "react";
import "./ProductShowcase.css";

const ProductShowcase = () => {
  return (
    <section className="product-showcase-section">
      <div className="container">
        <img 
          src="https://customer-assets-rejwkqb3.emergentagent.net/job_e06ae2b8-a1a2-4dfa-8908-44d6b0e390ff/artifacts/e6d94635987c6c10_1792845565532.webp"
          alt="Reta 1 Product Kit"
          className="product-showcase-image"
        />
      </div>
    </section>
  );
};

export default ProductShowcase;